<template>
  <AResult
    :class="getClasses"
    :title="props.title"
    :sub-title="props.subTitle"
    :status="props.status"
  >
    <template #icon v-if="!!$slots.icon">
      <slot name="icon" />
    </template>

    <template #extra v-if="!!$slots.extra">
      <slot name="extra" />
    </template>

    <template #default v-if="!!$slots.default">
      <slot name="reason" />
    </template>
  </AResult>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import {Result as AResult} from 'ant-design-vue';

import type {EAntResultStatus} from './enums';
import antTheme from '@/assets/ant/theme';

interface IProps {
  title?: string;
  subTitle?: string;

  status?: EAntResultStatus;

  loading?: boolean;
}

const {token} = antTheme.useToken();

const props = defineProps<IProps>();

const getColorPrimary = computed(() => token.value.colorPrimary);

const getClasses = computed(() => ({
  'ant-result-loading': props.loading,
}));
</script>

<style lang="scss">
.ant-result-loading {
  .ant-result-icon > .anticon {
    color: v-bind(getColorPrimary);
  }
}
</style>
